import styled, { css } from 'styled-components';

import { FadeIn } from '../animations/FadeIn';
import { FadeOut } from '../animations/FadeOut';

export const Visible = styled.div<{
	isVisible?: boolean;
}>`
	animation: ${(p) =>
			p.isVisible
				? css`
						${FadeIn}
					`
				: css`
						${FadeOut}
					`}
		0.3s forwards;
`;
